import api from 'api';
import { RecipeCustomCategories } from 'records/RecipeCustomCategory'

export const RECIPE_CUSTOM_CATEGORIES_ASYNC_ACTION_START = 'RECIPE_CUSTOM_CATEGORIES_ASYNC_ACTION_START';
export const RECIPE_CUSTOM_CATEGORIES_ASYNC_ACTION_ERROR = 'RECIPE_CUSTOM_CATEGORIES_ASYNC_ACTION_ERROR';
export const RECIPE_CUSTOM_CATEGORIES_ASYNC_UPDATE_SUCCESS = 'RECIPE_CUSTOM_CATEGORIES_ASYNC_UPDATE_SUCCESS';
export const RECIPE_CUSTOM_CATEGORIES_RESET_STATE = 'RECIPE_CUSTOM_CATEGORIES_RESET_STATE';
export const RECIPE_CUSTOM_CATEGORIES_UPDATE_SUCCESS = 'RECIPE_CUSTOM_CATEGORIES_UPDATE_SUCCESS';
export const RECIPE_CUSTOM_CATEGORIES_DRAGGABLE_UPDATE = 'RECIPE_CUSTOM_CATEGORIES_DRAGGABLE_UPDATE';
export const RECIPE_CUSTOM_CATEGORIES_UPDATE_ORDINALS_SUCCESS = 'RECIPE_CUSTOM_CATEGORIES_UPDATE_ORDINALS_SUCCESS';
export const RECIPE_CUSTOM_CATEGORIES_ORDINALS_DEBOUNCE = 'RECIPE_CUSTOM_CATEGORIES_ORDINALS_DEBOUNCE';

function recipeCustomCategoriesAsyncActionStart() {
  return {
    type: RECIPE_CUSTOM_CATEGORIES_ASYNC_ACTION_START,
  };
}

function recipeCustomCategoriesAsyncActionError(error) {
  return {
    type: RECIPE_CUSTOM_CATEGORIES_ASYNC_ACTION_ERROR,
    error,
  };
}

function recipeCustomCategoriesAsyncUpdateSuccess(data) {
  return {
    type: RECIPE_CUSTOM_CATEGORIES_ASYNC_UPDATE_SUCCESS,
    data,
  };
}

function recipeCustomCategoriesUpdateSuccess() {
  return {
    type: RECIPE_CUSTOM_CATEGORIES_UPDATE_SUCCESS,
  };
}

function recipeCustomCategoriesUpdateOrdinalsSuccess() {
  return {
    type: RECIPE_CUSTOM_CATEGORIES_UPDATE_ORDINALS_SUCCESS,
  };
}

export function updateDraggableCategories(data) {
  return {
    type: RECIPE_CUSTOM_CATEGORIES_DRAGGABLE_UPDATE,
    data,
  };
}

export function resetRecipeCustomCategoriesState() {
  return {
    type: RECIPE_CUSTOM_CATEGORIES_RESET_STATE,
  };
}

export function getRecipeCustomCategoriesAsync(brandId) {
  return (dispatch, getState) => {
    dispatch(recipeCustomCategoriesAsyncActionStart());
    return api.request(`userrecipeCategory/list?brandId=${brandId}`, 'get')
    .then((data) => {
      dispatch(recipeCustomCategoriesAsyncUpdateSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(recipeCustomCategoriesAsyncActionError('Unable to get Recipe Custom Categories List'));
      throw (err);
    });
  }
}

export function createRecipeCustomCategoriesAsync(recipeCustomCategories) {
  return (dispatch, getState) => {
    dispatch(recipeCustomCategoriesAsyncActionStart());
    return api.request('userrecipeCategory', 'post', recipeCustomCategories)
    .then((data) => {
      dispatch(recipeCustomCategoriesAsyncUpdateSuccess(data));
      return RecipeCustomCategories(data);
    })
    .catch((err) => {
      dispatch(recipeCustomCategoriesAsyncActionError('Unable to create Recipe Custom Category'));
      throw (err);
    });
  }
}

export function updateRecipeCustomCategoriesAsync(recipeCustomCategories) {
  return (dispatch, getState) => {
    dispatch(recipeCustomCategoriesAsyncActionStart());
    return api.request('userrecipeCategory', 'put', recipeCustomCategories)
    .then((data) => {
      dispatch(recipeCustomCategoriesAsyncUpdateSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(recipeCustomCategoriesAsyncActionError('Unable to update Recipe Custom Category'));
      throw (err);
    });
  }
}

export function deleteRecipeCustomCategoriesAsync(userCategoryId) {
  return (dispatch, getState) => {
    dispatch(recipeCustomCategoriesAsyncActionStart());
    return api.request(`userrecipeCategory/delete/${userCategoryId}`, 'delete')
    .then((data) => {
      dispatch(recipeCustomCategoriesUpdateSuccess());
      return data;
    })
    .catch((err) => {
      dispatch(recipeCustomCategoriesAsyncActionError('Unable to delete Recipe Custom Category'));
      throw (err);
    });
  }
}

export function updateCategoriesOrdinal(orderedCategories) {
  const thunk = (dispatch, getState) => {
    
    return api.request('userrecipeCategory/updateOrdinal', 'put', orderedCategories)
    .then((data) => {
      dispatch(recipeCustomCategoriesUpdateOrdinalsSuccess());
      return data;
    })
    .catch((err) => {
      dispatch(recipeCustomCategoriesAsyncActionError('Unable to order Recipe Custom Categories'));
      throw (err);
    });
  };
  thunk.meta = {
    debounce: {
      time: 500,
      key: RECIPE_CUSTOM_CATEGORIES_ORDINALS_DEBOUNCE,
    },
  };
  return thunk;
}
